module.exports = __webpack_public_path__ + "img/IncioCompleto.08a1d834.png";